import { Badge } from "baseui/badge"
import { FormattedMessage } from "react-intl"
import { IDriveTwoSpeed } from "./types"

export interface Aggregate2StateTextProps extends IDriveTwoSpeed
{   
    dontShowOff?: boolean
}
export const Aggregate2StateText = (props: Aggregate2StateTextProps) => {

    return (<>
        {props.isStep1 && <Badge hierarchy='secondary' color='positive' content={<><FormattedMessage id="Devices.Level" defaultMessage="Level" />{' 1'}</>} />}
        {props.isStep2 && <Badge hierarchy='secondary' color='positive' content={<><FormattedMessage id="Devices.Level" defaultMessage="Level" />{' 2'}</>} />}
        {(!props.isOn && !props.dontShowOff) && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="OFF" />} />}
    </>)
}